import IconixI1 from '../../../Media/Ruko BSD/Iconix Infinite/Iconix Infinite (1).webp'
import IconixI2 from '../../../Media/Ruko BSD/Iconix Infinite/Iconix Infinite (2).webp'
import IconixI3 from '../../../Media/Ruko BSD/Iconix Infinite/Iconix Infinite (3).webp'
import IconixI4 from '../../../Media/Ruko BSD/Iconix Infinite/Iconix Infinite (4).webp'

const IconixIimages =[
IconixI1,IconixI2,IconixI3,IconixI4
]

export default IconixIimages;
